import { getZIndex } from '@components/services/zIndex.js'
import { isEmpty } from '@utils/helper'

function Mask({ classname, color, opacity, onClick, zIndex }, overlayInstance, parentElement = 'body') {
  const classNameString = ['ph-mask', classname].join(' ')
  const actualZIndex = zIndex || getZIndex()
  const el = document.querySelector(parentElement)
  const styles = {
    'z-index': actualZIndex,
    'background-color': color,
    opacity: opacity
  }
  const styleString = formatStyles(styles)
  const n = document.createElement('div')
  n.innerHTML = `<div class="${classNameString}" style="${styleString}"></div>`
  this.$node = n.firstChild
  this.parentElement = parentElement
  this.parentNode = el
  this.$node.addEventListener('click', onClick)
  this.overlayInstance = overlayInstance
  this.shown = false
}

Mask.prototype.show = function() {
  if (this.shown || !this.overlayInstance.iShow) {
    return
  }
  this.parentNode.appendChild(this.$node)
  this.shown = true
  return this.shown
}

Mask.prototype.hide = function() {
  if (!this.shown) {
    return
  }
  this.parentNode.removeChild(this.$node)
  this.shown = false
  return this.shown
}

Mask.prototype.setVisibility = function (val) {
  if (val) {
    this.$node.style.visibility = 'visible'
  } else {
    this.$node.style.visibility = 'hidden'
  }
}

Mask.prototype.destroy = function () {
  if (!this.shown) {
    return
  }
  this.parentNode.removeChild(this.$node)
}

function formatStyles(styleObj) {
  const styles = []
  for (const key in styleObj) {
    if (Object.prototype.hasOwnProperty.call(styleObj, key) && !isEmpty(styleObj[key])) {
      styles.push(`${key}: ${styleObj[key]};`)
    }
  }
  return styles.join(' ')
}

export default Mask
